import type { Level } from "./types";

/** Stars earned (0–3) for watering `watered` palms on a level. */
export function starsFor(level: Level, watered: number): number {
  if (watered >= level.s3) return 3;
  if (watered >= level.s2) return 2;
  if (watered >= level.s1) return 1;
  return 0;
}
